import { createTheme, responsiveFontSizes } from '@mui/material/styles';
import { palette, darkPalette } from './palette';
import typography from './typography';
import components from './components';

// Create light theme
const lightThemeBase = createTheme({
  palette: {
    mode: 'light',
    ...palette,
  },
  typography,
  components,
  shape: {
    borderRadius: 8,
  },
  spacing: 8,
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 900,
      lg: 1200,
      xl: 1536,
    },
  },
  shadows: [
    'none',
    '0 1px 3px rgba(0,0,0,0.08)',
    '0 2px 6px rgba(0,0,0,0.08)',
    '0 4px 12px rgba(0,0,0,0.08)',
    '0 6px 16px rgba(0,0,0,0.08)',
    '0 8px 20px rgba(0,0,0,0.10)',
    '0 10px 24px rgba(0,0,0,0.10)',
    '0 12px 28px rgba(0,0,0,0.10)',
    '0 14px 32px rgba(0,0,0,0.12)',
    '0 16px 36px rgba(0,0,0,0.12)',
    '0 18px 40px rgba(0,0,0,0.12)',
    '0 20px 44px rgba(0,0,0,0.14)',
    '0 22px 48px rgba(0,0,0,0.14)',
    '0 24px 52px rgba(0,0,0,0.14)',
    '0 26px 56px rgba(0,0,0,0.16)',
    '0 28px 60px rgba(0,0,0,0.16)',
    '0 30px 64px rgba(0,0,0,0.16)',
    '0 32px 68px rgba(0,0,0,0.18)',
    '0 34px 72px rgba(0,0,0,0.18)',
    '0 36px 76px rgba(0,0,0,0.18)',
    '0 38px 80px rgba(0,0,0,0.20)',
    '0 40px 84px rgba(0,0,0,0.20)',
    '0 42px 88px rgba(0,0,0,0.20)',
    '0 44px 92px rgba(0,0,0,0.22)',
    '0 46px 96px rgba(0,0,0,0.22)',
  ],
});

// Create dark theme
const darkThemeBase = createTheme({
  palette: {
    mode: 'dark',
    ...darkPalette,
  },
  typography,
  components: {
    ...components,
    MuiCssBaseline: {
      styleOverrides: {
        ...components.MuiCssBaseline.styleOverrides,
        body: {
          ...components.MuiCssBaseline.styleOverrides.body,
          backgroundColor: '#0A1628',
        },
      },
    },
  },
  shape: {
    borderRadius: 8,
  },
  spacing: 8,
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 900,
      lg: 1200,
      xl: 1536,
    },
  },
});

// Apply responsive font sizes
export const lightTheme = responsiveFontSizes(lightThemeBase);
export const darkTheme = responsiveFontSizes(darkThemeBase);

export { palette, darkPalette, typography, components };
export default lightTheme;
